import { SocketService } from './socket.service';
import { DataService } from './data.service';
var BusinessEventService = (function () {
    function BusinessEventService(_data, _socket) {
        this._data = _data;
        this._socket = _socket;
        this.socketType = 'notifySocket';
    }
    BusinessEventService.prototype.open = function () {
        var deskId = this._data.session["desk"];
        this._socket.initSocket(deskId, this.socketType);
    };
    BusinessEventService.prototype.close = function () {
        this._socket.clearSocket(this.socketType);
    };
    BusinessEventService.prototype.onMessage = function () {
        return this._socket.getMessageObservable(this.socketType);
    };
    BusinessEventService.prototype.onOpen = function () {
        return this._socket.getOpenObservable(this.socketType);
    };
    BusinessEventService.prototype.onClose = function () {
        return this._socket.getCloseObservable(this.socketType);
    };
    return BusinessEventService;
}());
export { BusinessEventService };
